import { render } from "./CardGrupoXilema.vue?vue&type=template&id=6020fd08&scoped=true"
import script from "./CardGrupoXilema.vue?vue&type=script&lang=js"
export * from "./CardGrupoXilema.vue?vue&type=script&lang=js"

import "./CardGrupoXilema.vue?vue&type=style&index=0&id=6020fd08&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6020fd08"]])

export default __exports__